//---- REACT and JS 
import React from "react";
//---- Ant Design
import { Carousel } from "antd";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
//---- Project
import placeHolderImage from "assets/images/placeHolder.svg";


const statusColorCode = {
    Poor: "#ff0000",
    Average: "#F07900",
    Good: "#ffff04",
    Excellent: "#04ff00",
    Low: "#ff0000",
    High: "#F07900",
    Normal: "#04ff00",
};  


const VehicleCarousel = ({profileImages, partsHovered, setPartsHovered}) => {
    
    const onCarouselChange = (viewPos) => {};

    const partMouseOver = (e) => {
        setPartsHovered((prev) => ({
          ...prev,
          [e.target.id]: true,
          activePart: e.target.id,
          activeInfo: prev?.info?.[e.target.id],
        }));
      };
    
      const partMouseOut = () => {
        setPartsHovered((prev) => ({ status: prev.status, info: prev.info }));
      };
    
    return(
        <>
            {profileImages &&
            Object.keys(profileImages).length ? (
            <Carousel
                arrows
                dots={false}
                afterChange={onCarouselChange}
                prevArrow={<LeftCircleOutlined />}
                nextArrow={<RightCircleOutlined />}
            >
                {Object.keys(profileImages)?.map(
                (img, index) => (
                    <div key={index} className="vehicle-part-image-box">
                    <img
                        key={index}
                        alt="Vehicle"
                        src={profileImages[img].url}
                        className="vehicle-part-image"
                    />
                    <svg className="vehicle-part-image-overlay">
                        {profileImages[
                        img
                        ]?.partListCoordinates?.map((part, index) => {
                        if (part?.partLabel && part?.x && part?.y) {
                            return statusColorCode[
                            partsHovered?.status?.[part?.partLabel]
                            ] ? (
                            <circle
                                key={index}
                                id={part?.partLabel}
                                cx={part?.x}
                                cy={part?.y}
                                r={
                                partsHovered[part?.partLabel] &&
                                partsHovered?.activePart === part?.partLabel
                                    ? 14
                                    : 9
                                }
                                fill={
                                statusColorCode[
                                    partsHovered?.status?.[part?.partLabel]
                                ] || "#6897bb"
                                }
                                onMouseOver={(e) => partMouseOver(e)}
                                onMouseOut={partMouseOut}
                            />
                            ) : (
                            <>
                                <circle
                                key={index}
                                id={part?.partLabel}
                                cx={part?.x}
                                cy={part?.y}
                                r={
                                    partsHovered[part?.partLabel] &&
                                    partsHovered?.activePart ===
                                    part?.partLabel
                                    ? 10
                                    : 9
                                }
                                onMouseOver={(e) => partMouseOver(e)}
                                onMouseOut={partMouseOut}
                                stroke="red"
                                stroke-width="2"
                                fill="white"
                                />
                                <rect
                                x={part?.x - 1}
                                y={part?.y - 4}
                                width="2"
                                height="6"
                                fill="red"
                                id={part?.partLabel}
                                onMouseOver={(e) => partMouseOver(e)}
                                onMouseOut={partMouseOut}
                                />
                                <rect
                                x={part?.x - 1}
                                y={part?.y + 3}
                                width="2"
                                height="2"
                                fill="red"
                                id={part?.partLabel}
                                onMouseOver={(e) => partMouseOver(e)}
                                onMouseOut={partMouseOut}
                                />
                            </>
                            );
                        } else {
                            return null;
                        }
                        })}
                    </svg>
                    </div>
                )
                )}
            </Carousel>
            ) : (
            <div className="vehicle-part-image-box">
                <img
                alt="Vehicle"
                width="400"
                height="400"
                src={placeHolderImage}
                className="vehicle-part-image"
                />
            </div>
            )}
        </>
    )
}

export default VehicleCarousel;